import type { propertyToMethodMap } from '../map-field-property-to-api-method';

export const FIELD_VALIDATION_ERROR = 'FIELD_VALIDATION_FAILED';

export type ValidationError = {
	fieldType: string;
	fieldId: string;
	type: typeof FIELD_VALIDATION_ERROR;
	method: (typeof propertyToMethodMap)[keyof typeof propertyToMethodMap];
	message?: string;
};

type ErrorAttributes = { errors: ValidationError[] };

export class UiModificationsFieldsValidationError extends Error {
	attributes: ErrorAttributes;

	constructor(message: string, attributes: ErrorAttributes, cause?: ErrorOptions) {
		super(message, cause);

		this.attributes = attributes;
	}
}
